import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, ref, watch } from 'vue'
import LfActionsBarComponent from '@/components/ActionsBar/LfActionsBarComponent.vue'
import { ActionBarButton } from '@/components/ActionsBar/types/ActionBarComponentTypes'
import { ComponentWhereIsRendered } from '@/store/modules/alerts/alertsTypes'
import AlertComponent from '@/components/Alert/AlertComponent.vue'
import LfHeaderTooltipComponent from '@/components/HeaderTitle/LfHeaderTooltipComponent.vue'

type ActionFunction = ((payload: MouseEvent) => void) | ((actionName: string) => Promise<void>)

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'LfHeaderTitleComponent',
  props: {
  title: {
    type: String as PropType<string>,
    required: true
  },
  buttons: {
    type: Array as PropType<ActionBarButton[]>,
    default: () => []
  },
  executeAction: {
    type: Function as PropType<ActionFunction>,
    required: false
  },
  showKebabMenu: {
    type: Boolean as PropType<boolean>,
    default: false
  },
  badgeTooltip: {
    type: String as PropType<string>,
    required: false
  },
  badgeIcon: {
    type: String as PropType<string>,
    required: false
  }
},
  setup(__props) {

const props = __props;



// DATA
const componentWhereIsRendered = ComponentWhereIsRendered.LF_HEADER_TITLE
// Referencias para comprobar si se renderiza una elipsis en el nombre
const textContainerElement = ref<Element | null>(null)
const textElement = ref<Element | null>(null)
const isTruncated = ref(false)

// COMPUTED
const showButtons = computed(() => props.buttons && props.buttons.length > 0)

// WATCHERS
watch(
  () => props.title,
  () => {
    setTimeout(() => {
      checkIfTruncated()
    })
  }
)

// METHODS
function checkIfTruncated() {
  if (textContainerElement.value && textElement.value) {
    const container = textContainerElement.value
    const text = textElement.value
    isTruncated.value = text.scrollWidth > container.clientWidth
  }
}

return { __sfc: true,props, componentWhereIsRendered, textContainerElement, textElement, isTruncated, showButtons, checkIfTruncated, LfActionsBarComponent, AlertComponent, LfHeaderTooltipComponent }
}

})